export default "__VITE_ASSET__Co8S8HaE__"